export default __webpack_public_path__ + "static/about3-5a7a8e0bdce5cc64882893500fa63878.jpg";